/**
 * Checks wether given value is number. Symbols `+` and `-` at the beginning are not allowed.
 * For decimal values only `.` is allowed.
 * Acceptable values: `1`, `1.1`, `1,1`
 */
// eslint-disable-next-line no-useless-escape
export const isValidNumber = (value: string | number) => /^[0-9]+[\.]?[0-9]*$/.test(String(value));
